<template>
  <div>
    <div class="cg-grid-row">
      <span />
      <div class="cg-strip">
        <span
          v-for="m in MONTHS"
          :key="m"
          class="cg-strip-cell cg-micro text-center"
          >{{ m }}</span
        >
      </div>
    </div>
    <div v-for="row in rows" :key="row.key" class="cg-grid-row">
      <span class="small text-truncate pe-2">{{ row.name }}</span>
      <div class="position-relative">
        <div class="cg-strip cg-runs">
          <div
            v-for="(run, i) in row.runs"
            :key="i"
            class="cg-run"
            :style="{ flex: `${run.grow} 1 0`, background: FILL[run.fill] }"
          />
        </div>
        <div class="cg-overlay">
          <MonthStrip :cells="row.cells" :height="28" />
        </div>
      </div>
    </div>
    <LegendSwatches :legend />
  </div>
</template>

<script setup lang="ts">
import { MONTHS } from "@/compliance_groups/fixture/complianceGroupsFixture";
import type {
  CompletenessRow,
  LegendItem,
} from "@/compliance_groups/fixture/derive";
import { FILL } from "@/compliance_groups/fixture/fills";
import LegendSwatches from "./LegendSwatches.vue";
import MonthStrip from "./MonthStrip.vue";

// Consecutive months of the same basis render as one run (so a quarter reads as one block) while
// the transparent MonthStrip overlay keeps per-month hover popovers.
defineProps<{ rows: CompletenessRow[]; legend: LegendItem[] }>();
</script>

<style scoped lang="scss">
.cg-grid-row {
  display: grid;
  grid-template-columns: minmax(96px, 150px) 1fr;
  gap: 3px;
  align-items: center;
  padding: 5px 0;
}
.cg-runs {
  gap: 3px;
}
.cg-run {
  min-width: 0;
  height: 28px;
  border-radius: 4px;
}
.cg-overlay {
  position: absolute;
  inset: 0;
}
.cg-overlay :deep(.cg-strip-cell) {
  background: transparent !important;
}
.cg-overlay :deep(.cg-strip) {
  gap: 3px;
}
</style>
